export const useDeclination = (count: number, one: string, two: string, five: string): string => {
    count = Math.floor(count) % 100;
    if (count > 10 && count < 20) {
        return five;
    }
    count = count % 10;
    if (count === 1) { return one; }
    if (count >= 2 && count <= 4) { return two; }
    return five;
}